import better_learning_outcomes from "./assets/better_learning_outcomes.webp";
import boosted_confidence from "./assets/boosted_confidence.webp";
// import certificate from "./assets/certificate.webp";
import comprehensive_skill_building from "./assets/comprehensive_skill_building.webp";
import desktop_2 from "./assets/desktop-2.webp";
import enhanced_capability from "./assets/enhanced_capability.webp";
import iit_building from "./assets/iitb_building.webp";
import networking_opportunities from "./assets/networking_opportunities.webp";
// import "./programPage.css";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Image,
  Row,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { courses, faq_pdf } from "Constants/courses";
import { FaHouseChimney } from "react-icons/fa6";
import { classNames } from "Store/utils";
import trustEdgeStyles from "TrustEdge.module.css";
import FooterTrust from "Screens_old/Footer/FooterTrust";
// import ReviewSlider from "Screens_old/ReviewSlider/ReviewSlider";
import { downloadBrochure } from "Utils/brochureUtils";
import BrochureNotAvailableModal from "Components/BrochureNotAvailableModal";
import { useState } from "react";

const ProgramPage = () => {
  const { id } = useParams();
  const params = useParams();
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [modalCourseName, setModalCourseName] = useState('');
  const course = courses.find((course) => course.id === parseInt(id));
  const applyFormURL = [5, 6, 7, 8].includes(course?.id) ? "https://forms.gle/gwtEJx8yGt5tmgU7A" : "https://docs.google.com/forms/d/164dEI9sipU0u72BXJ9TX6CArQFCz5U9DrgEeosz4o3w/viewform?edit_requested=true";

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  const programBenefits = [
    {
      icon: `${comprehensive_skill_building}`,
      name: "Comprehensive Skill Building",
      description:
        "Gain a deep, structured understanding from basics to advanced topics, making you versatile and proficient in the field.",
    },
    {
      icon: `${better_learning_outcomes}`,
      name: "Better Learning Outcomes",
      description:
        "Later courses have earlier courses as prerequisites and often build on them. Following a sequence can significantly enhance understanding and mastery of the subject.",
    },
    {
      icon: `${enhanced_capability}`,
      name: "Enhanced Credibility",
      description:
        "A professional certificate holds more weight and can make a stronger impression on employers, as it shows commitment to learning and a higher level of expertise.",
    },
    {
      icon: `${networking_opportunities}`,
      name: "Networking Opportunities",
      description:
        "Connect with dedicated peers over the courses, fostering collaboration, peer learning, and potential job referrals.",
    },
    {
      icon: `${boosted_confidence}`,
      name: "Boosted Confidence",
      description:
        "Completing a full series builds self-assurance. This can help perform better in job interviews, assessments, and even real-world scenarios.",
    },
  ];

  const handleShowBrochureModal = (courseName) => {
    setModalCourseName(courseName);
    setShowBrochureModal(true);
  };

  // Function to handle brochure download
  const handleDownloadBrochure = () => {
    downloadBrochure(course.id, course.program_title, handleShowBrochureModal);
  };

  return (
    <Container fluid className="px-0">
      {/* <NavigationBar /> */}
      <Container fluid style={{ backgroundColor: "rgb(235 241 255)" }}>
        <Container
          fluid
          className="d-flex h-100 align-items-center py-2"
          style={{
            maxWidth: "1600px",
          }}
        >
          <Breadcrumb className={classNames(trustEdgeStyles['size14'], "ps-2 my-0")}>
            <BreadcrumbItem href="/">
              <FaHouseChimney color={"rgb(54, 54, 54)"} />
            </BreadcrumbItem>
            {course.category === "Professional Certificate" && (
              <BreadcrumbItem
                href="/#programs-we-offer"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/#programs-we-offer";
                }}
              >
                Programs
              </BreadcrumbItem>
            )}
            <BreadcrumbItem
              href={`/program/${id}`}
              className="text-decoration-none"
            >
              {course.program_title}
            </BreadcrumbItem>
          </Breadcrumb>
        </Container>
      </Container>

      <Container
        className="w-100"
        fluid
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4)), url(${desktop_2})`,
          backgroundSize: "cover",
          backgroundPosition: "top left, bottom right",
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundBlendMode: "overlay",
        }}
      >
        <Container
          style={{
            maxWidth: "1600px",
          }}
        >
          <Row className="pt-5 justify-content-center align-items-center">
            <Col xs={12} sm={12} md={6} lg={6} className="text-left mb-4 mb-md-0">
              <h1 className="top-heading mb-4">{course.program_title}</h1>
              <p
                className="trustedge_size18 mb-0"
                dangerouslySetInnerHTML={{ __html: course.description }}
              ></p>
              <Row className="mt-4">
                <Col xs={12} sm={6} md={12} lg={6} className="mb-2 mb-sm-0">
                  <Button
                    className="apply-btn my-0 w-100"
                    as="a"
                    href={applyFormURL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apply Now
                  </Button>
                </Col>
                <Col xs={12} sm={6} md={12} lg={6}>
                  <button
                    className="download-btn m-0 w-100"
                    onClick={handleDownloadBrochure}
                  >
                    Download Brochure
                  </button>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <div className="ms-lg-3 p-lg-3">
                <img
                  className="w-100"
                  style={{
                    borderRadius: "10px",
                    height: "auto",
                    maxHeight: "400px",
                    objectFit: "cover"
                  }}
                  src={iit_building}
                  alt="IIT Building"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Program Highlights */}
      <Container
        fluid
        className="px-0"
      // style={{ background: "#ECF4FF" }}
      >
        <Container>
          <Row className="d-flex justify-content-between">
            <Col
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="d-flex justify-content-center"
            >
              <div className="trustedge_size18 d-flex flex-column justify-content-center">
                <h4>Program Highlights</h4>
                <ul>
                  <li>
                    Certificate from IIT Bombay, the leading institute for Computer Science in India
                  </li>
                  <li>
                    Conducted by award-winning teaching faculty
                  </li>

                  <li>
                    Continuous hands-on learning via weekly labs as opposed to an end-of-term course project
                  </li>
                  <li>
                    Comprehensive, industry-aligned curriculum built on real-world standards.
                  </li>
                  <li>
                    Experience the same structure as IITB’s in-person programs: immersive learning with TA support and proctored on-campus theory+lab exams
                  </li>
                  <li>
                    In-person evaluations for credibility and authenticity.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12} className="p-lg-5 p-2">
              <img src={course?.certificate} className="my-2 img-fluid" />
            </Col>
          </Row>
        </Container>
      </Container>

      {/*  Why Plan*/}
      <Container fluid className="pb-0 pb-md-5 px-0 py-0 py-md-3" style={{ background: "#fafafa" }}>
        <h2 className="text-center p-md-3 p-2">
          Why Plan for a Professional Certificate from the Start?
        </h2>
        <Container className="pb-md-0 pb-3">
          <Row className="row-cols-lg-5 row-cols-sm-2 row-cols-1 d-flex justify-content-center g-md-3 g-1">
            {programBenefits.map((step, i) => {
              return (
                <Col
                  key={`${i}_step`}
                  className="d-flex justify-content-evenly"
                >
                  <div
                    className="d-flex flex-column justify-content-start align-items-start py-md-0 py-2"
                    style={{ paddingLeft: "8px", width: "100%" }}
                  >
                    <Image
                      src={step.icon}
                      className="mb-md-4 mb-2 mt-md-4 mt-1"
                      alt="Feature Icon"
                      style={{ width: "50px" }}
                    />
                    <p
                      className="mb-md-2 mb-1 mt-0 trustedge_size18 weight400 propositions-title"
                      style={{ color: "#000" }}
                    >
                      {step.name}
                    </p>

                    <p
                      className={classNames(trustEdgeStyles['size14'], "px-0 weight400 text-left mb-0 mt-0")}
                      style={{ color: "#757589" }}
                    >
                      {step.description}
                    </p>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </Container>

      {/* Current Offerings */}
      <Container fluid className="pb-0 pb-md-5 courses-section">
        <Container fluid className={classNames(trustEdgeStyles['container-width'], "pt-4 pb-4")}>
          <h2 className="text-center mb-5">Current Offerings</h2>
          <Row id="current-offerings" className="g-3 justify-content-center">
            {course?.subCourses?.map((subCourse, index) => {
              const course = courses.find((c) => c.id === subCourse.courseId);

              const isComingSoonCourse = subCourse.courseId === 3;
              const isRegistrationClosedCourse = subCourse.courseId === 8 || subCourse.courseId === 5;
              const isAcceptingApplicationsCourse = subCourse.courseId === 7;
              return (
                <Col key={index} xs={12} sm={12} md={6} lg={4} xl={3}>
                  <a
                    href={`/course/${subCourse.courseId}`}
                    className="course-link"
                    style={{ textDecoration: 'none', color: 'inherit', height: '100%', display: 'block' }}
                  >
                    <div
                      className="d-flex flex-column shadow border rounded program-page-offerings"
                      style={{
                        background: "#ffffff",
                        margin: "5px",
                        height: "450px", // Fixed height for all cards
                      }}
                    >
                      {isComingSoonCourse && (
                        <div className="ongoing_ribbon" style={{ backgroundColor: "#ffb366" }}>
                          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
                            Upcoming
                          </span>
                        </div>
                      )}
                      {isRegistrationClosedCourse && (
                        <div className="ongoing_ribbon" style={{ backgroundColor: "#ffb366" }}>
                          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
                            Registration Closed
                          </span>
                        </div>
                      )}
                      {isAcceptingApplicationsCourse && (
                        <div className="ongoing_ribbon" style={{ backgroundColor: "#6f42c1" }}>
                          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
                            Accepting Applications
                          </span>
                        </div>
                      )}
                      {/* Image Section - Fixed Height */}
                      <div className="px-0 d-flex align-items-center" style={{ height: "180px", flexShrink: 0 }}>
                        <img
                          src={course ? course.image : ""}
                          alt={subCourse.title}
                          className="img-fluid rounded-top w-100 mobile-img"
                          style={{
                            objectFit: "cover",
                            height: "100%",
                          }}
                        />
                      </div>

                      {/* Content Section - Fixed Height */}
                      <div className="p-3" style={{ height: "130px", overflow: "hidden" }}>
                        <h5 className={classNames(trustEdgeStyles['size16'], "mb-2")} style={{
                          lineHeight: "1.3",
                          height: "40px", // Fixed height for title
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical"
                        }}>
                          {subCourse.title}
                        </h5>
                        <p className={classNames("text-muted mb-2", trustEdgeStyles['size16'])} style={{
                          height: "60px" // Fixed height for duration/start date
                        }}>
                          {subCourse.duration}
                          <br />
                          Starts: {subCourse.startDate}
                          <br />
                          {subCourse?.category}
                        </p>
                      </div>

                      {/* Job Roles Section - Fixed Position from Bottom */}
                      <div className="p-3 pt-2" style={{
                        height: "150px", // Fixed height for job roles section
                        borderTop: "1px solid #e9ecef",
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        {/* Job Roles Title - Always at the same position */}
                        <h6 className={classNames(trustEdgeStyles['size16'], "mb-1")} style={{
                          height: "20px", // Fixed height for the title
                          lineHeight: "20px",
                          flexShrink: 0
                        }}>
                          Potential Job Roles:
                        </h6>

                        {/* Job Roles Content - Scrollable if needed */}
                        <div style={{
                          flex: 1,
                          overflow: "auto",
                          paddingRight: "8px"
                        }}>
                          <p className={classNames(trustEdgeStyles['size12'], "mb-0")} style={{
                            lineHeight: "1.4"
                          }}>
                            {subCourse.jobRoles.join(", ")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </Col>
              );
            })}
          </Row>
        </Container>
      </Container>
      {/* Market Trends */}
      <Container fluid className="px-0">
        <Container className="{classNames(trustEdgeStyles['container-width'])} py-3 my-2">
          <h2 className="text-center mb-4">Market Trends</h2>
          <p className="trustedge_size20 text-center">
            {course?.market_trends_title}
          </p>
          {/* <Row className="mt-4 d-flex">
            {course?.trends?.map((trend, index) => {
              return (
                <Col key={index} md={4} className="mb-4 d-flex">
                  <div className="text-left shadow p-3 flex-fill">
                    <h5 className="mb-2">{trend.description}</h5>
                    <p className="trustedge_size18">
                      Source:{" "}
                      <a
                        href={trend.source}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {trend.source_title}
                      </a>
                    </p>
                  </div>
                </Col>
              );
            })}
          </Row> */}
        </Container>
      </Container>
      <Container fluid className="px-0" >
        <Container className={classNames(trustEdgeStyles['container-width'],)}>
          <Row className="">
            {/* Left Column - Trends */}
            <Col xs={12} sm={12} md={6} className="pe-md-5 d-flex flex-column">
              {course?.trends?.map((trend, index) => (
                <div
                  key={index}
                  className="text-left p-3 mb-4 flex-fill trends-border"
                >
                  <h5 className="mb-2">{trend.description}</h5>
                  <p className="trustedge_size18">
                    Source:{" "}
                    <a
                      href={trend.source}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {trend.source_title}
                    </a>
                  </p>
                </div>
              ))}
            </Col>

            {/* Right Column - Image */}
            <Col
              sm={12}
              md={6}
              className="d-flex justify-content-center align-items-start mb-3"
            >
              <img
                src={course.trends_img}
                className="trends-img-border"
                alt="Market Trends"
                style={{ width: "100%", height: "auto" }}
              />
            </Col>
          </Row>
        </Container>
        <Container fluid className="px-4 d-flex justify-content-center">
          <h2 className="my-5">
            What are you waiting for? Know more about the <span
              style={{
                whiteSpace: "nowrap",
                color: "#338bd9",
                cursor: "pointer",
              }}
              onClick={() => {
                const element = document.getElementById('current-offerings');
                element?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }}
            >courses</span> and{" "}
            <span
              style={{
                whiteSpace: "nowrap",
                color: "#338bd9",
                cursor: "pointer",
              }}
              onClick={() => {
                // Link to Google Forms registration
                window.open(applyFormURL, '_blank', 'noopener,noreferrer');
              }}
            >
              apply now.
            </span>
            {" "}Any questions, visit our <span
              style={{
                whiteSpace: "nowrap",
                color: "#338bd9",
                cursor: "pointer",
              }}
              onClick={() => {
                // Link to Google Forms registration
                window.open(faq_pdf, '_blank', 'noopener,noreferrer');
              }}
            >
              FAQ
            </span>.
          </h2>
        </Container>
      </Container>

      {/* Review Slider */}
      {/* {course?.reviews?.length > 0 && (
        <Container
          fluid
          className="py-3 py-md-5 user-select-none pb-3 pb-md-5"
          style={{ background: "#fafafa" }}
        >
          <Container className={classNames(trustEdgeStyles['container-width'], "px-2 px-md-4 mb-3 mb-md-5")}>
            <h2 className="py-3 py-md-5 px-2 px-md-4 text-center text-md-start fs-4 fs-md-2">
              See what our users say
            </h2>
            <div className="px-1 px-md-4 mb-3 mb-md-5">
              <ReviewSlider reviews={course?.reviews} />
            </div>
          </Container>
        </Container>
      )} */}
      <FooterTrust />
      <BrochureNotAvailableModal
        show={showBrochureModal}
        onHide={() => setShowBrochureModal(false)}
        courseName={modalCourseName}
      />
    </Container>
  );
};

export default ProgramPage;
